"use client";

import createIcon from './util/createIcon';
export default createIcon('M12 22L1 3H23M12 18L19.53 5H4.47', 'TriangleDownOutline');